import { isNull, keys } from 'lodash';
// Import Constants
import { ErrorShowType, l, TemplateInputTypes, DeniedTags } from 'constants/common';

const bodyScenario = {
    isValid: null,
    errorText: '',
    value: '',
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'requiredEmailBuilder',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
        {
            ValidationType: 'deniedTagsNotAllowed',
            ErrorMessage: l.InvalidHtmlTags,
            ParametersValues: { tags: DeniedTags.dynamicPopUp, isPartial: false },
            TranslationVariables: { deniedTags: DeniedTags.dynamicPopUp.join(', ') },
        },
    ],
};

const dynamicPopUpTemplateValidationScenario = () => ({
    Name: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
            {
                ValidationType: 'firstSymbol',
                ErrorMessage: l.NameFirstCharacterCantBeASymbol,
                ParametersValues: /^[\p{L}0-9]/gu,
            },
            {
                ValidationType: 'minLength',
                ErrorMessage: l.MustContainMinimumCharacters,
                ParametersValues: '3',
            },
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '50',
            },
        ],
    },
    Description: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '250',
            },
        ],
    },
    CrossValidation: {
        isValid: null,
        errorText: '',
        value: {},
        type: ErrorShowType.Toaster,
        validationCredentials: [
            {
                ValidationType: 'templateCrossValidation',
                ErrorMessage: '',
                ParametersValues: [TemplateInputTypes.Body],
            },
        ],
    },
    ForbiddenDynamicVariables: {
        isValid: null,
        errorText: '',
        value: {},
        type: ErrorShowType.Toaster,
        validationCredentials: [
            {
                ValidationType: 'templateForbiddenDynamicVariables',
                ErrorMessage: '',
                ParametersValues: [TemplateInputTypes.Body],
            },
        ],
    },
    ExpirationType: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'expirationDateTimeGreaterThanNow',
                ErrorMessage: l.ExpirationDateMustBeGreaterThanNow,
                ParametersValues: null,
            },
        ],
    },
    ExpirationPeriod: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'expirationTypePeriodValidation',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
        ],
    },
    ExpirationDate: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'expirationTypeDateValidation',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
        ],
    },
    ExpirationTime: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'expirationTypeDateTimeValidation',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
        ],
    },
    Timezone: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'expirationTypeDateTimeZoneValidation',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
        ],
    },
    defaultLangBody: { ...bodyScenario },
});

function dynamicPopUpTemplateScenarioPropertiesCreator(data, editCloneMode, _addData = {}, additionalData = {}) {
    const defaultScenario = dynamicPopUpTemplateValidationScenario();

    const validationScenario: AnyObject =
        keys(additionalData)?.reduce((acc, key) => {
            acc[key] = {
                ...defaultScenario[key],
                value: additionalData[key],
            };
            return acc;
        }, {}) ?? {};

    if (editCloneMode) {
        Object.assign(
            validationScenario,
            keys(data).reduce((acc, id) => {
                acc[`${id}Body`] = {
                    ...bodyScenario,
                    isValid: isNull(data[id].isValid) ? null : true,
                    value: data[id].Body,
                };

                return acc;
            }, {}),
        );
    } else {
        Object.assign(
            validationScenario,
            data.reduce((acc, id) => {
                acc[`${id}Body`] = bodyScenario;

                return acc;
            }, {}),
        );
    }

    return validationScenario;
}

export { dynamicPopUpTemplateValidationScenario, dynamicPopUpTemplateScenarioPropertiesCreator };
